import { Injectable } from '@angular/core';
import {
    Http,
    ConnectionBackend,
    RequestOptions,
    RequestOptionsArgs,
    Request,
    Response,
    Headers
} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/finally';

import { LoaderService } from "./loader-service";
import { AuthenticationService } from './authentication.service';
import { Configuration } from '../configurations/shared.config';

@Injectable()
export class HttpService extends Http {

    private loaderService: LoaderService;
    private auth: AuthenticationService;

    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions) {
        super(backend, defaultOptions);
        this.loaderService = new LoaderService();
        this.auth = new AuthenticationService(this, null);
    }

    /**
     * Performs any type of http request.
     * @param url
     * @param options
     * @returns {Observable<Response>}
     */
    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return super.request(url, options);
    }

    /**
     * Performs a request with `get` http method.
     * @param url
     * @param options
     * @returns {Observable<>}
     */
    get(url: string, options?: RequestOptionsArgs, isLoader: boolean = true): Observable<any> {

        if (isLoader) {
            this.requestInterceptor();
        }

        return super.get(url, this.requestOptions(url, options))
            .catch(this.onCatch)
            .do((res: Response) => {
                this.onSubscribeSuccess(res);
            }, (error: any) => {
                this.onSubscribeError(error);
            })
            .finally(() => {
                if (isLoader) {
                    this.onFinally();
                }
            });
    }

    getLocal(url: string, options?: RequestOptionsArgs): Observable<any> {
        return super.get(url, options);
    }

    /**
     * Performs a request with `post` http method.
     * @param url
     * @param body
     * @param options
     * @returns {Observable<>}
     */
    post(url: string, body: any, options?: RequestOptionsArgs, isLoader: boolean = true): Observable<any> {
        if (isLoader) {
            this.requestInterceptor();
        }

        return super.post(url, body, this.requestOptions(url, options))
            .catch(this.onCatch)
            .do((res: Response) => {
                this.onSubscribeSuccess(res);
            }, (error: any) => {
                this.onSubscribeError(error);
            })
            .finally(() => {
                if (isLoader) {
                    this.onFinally();
                }
            });
    }



    /**
     * Performs a request with `put` http method.
     * @param url
     * @param body
     * @param options
     * @returns {Observable<>}
     */
    put(url: string, body: string, options?: RequestOptionsArgs): Observable<any> {
        this.requestInterceptor();
        return super.put(url, body, this.requestOptions(url, options))
            .catch(this.onCatch)
            .do((res: Response) => {
                this.onSubscribeSuccess(res);
            }, (error: any) => {
                this.onSubscribeError(error);
            })
            .finally(() => {
                this.onFinally();
            });
    }

    /**
     * Performs a request with `delete` http method.
     * @param url
     * @param options
     * @returns {Observable<>}
     */
    delete(url: string, options?: RequestOptionsArgs): Observable<any> {
        this.requestInterceptor();
        return super.delete(url, this.requestOptions(url, options))
            .catch(this.onCatch)
            .do((res: Response) => {
                this.onSubscribeSuccess(res);
            }, (error: any) => {
                this.onSubscribeError(error);
            })
            .finally(() => {
                this.onFinally();
            });
    }


    /**
     * Request options.
     * @param options
     * @returns {RequestOptionsArgs}
     */
    private requestOptions(url: string, options?: RequestOptionsArgs): RequestOptionsArgs {
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }

        if (url.indexOf(Configuration.urls.webApiEndpoint) >= 0) {
            if (this.auth.validUser())
                options.headers.append('Authorization', 'Bearer ' + this.auth.getCurrentUser().access_token)
        }
        return options;
    }


    /**
    * A counter to track the number of requests that are still in progress
    */
    loaderCount = 0;

    /**
     * Request interceptor.
     */
    private requestInterceptor(): void {
        // show the loader only if there are no requests
        if (this.loaderCount == 0) {
            this.loaderService.showPreloader();
        }
        // increment the number of requests
        this.loaderCount++;
    }

    /**
     * Response interceptor.
     */
    private responseInterceptor(): void {
        // decrement the number of requests
        if (this.loaderCount > 0) {
            this.loaderCount--;
        }
        // hide the loader when there are no requests
        if (this.loaderCount == 0) {
            this.loaderService.hidePreloader();
        }
    }

    /**
     * Error handler.
     * @param error
     * @param caught
     * @returns {ErrorObservable}
     */
    private onCatch(error: any, caught: Observable<any>): Observable<any> {
        return Observable.throw(error);
    }

    /**
     * onSubscribeSuccess
     * @param res
     */
    private onSubscribeSuccess(res: Response): void {
    }

    /**
     * onSubscribeError
     * @param error
     */
    private onSubscribeError(error: any): void {
    }

    /**
     * onFinally
     */
    private onFinally(): void {
        this.responseInterceptor();
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/http.service.ts